<template>
    <div class="container margin-top">
        <h1 class="text-center my-5">POLÍTICA DE PRIVACIDAD</h1>
        <p class="text-justify">Somos <b>SAVI MARKETING SOLUTIONS S.L.</b>, y su confianza es muy importante para nosotros. Respetando su privacidad, hemos implementado las mejores medidas para proteger sus datos personales para que pueda sentirse seguro con nosotros. El documento que está leyendo en este momento describe los principios de tratamiento de sus datos personales por nuestra parte. Nos preocupamos constantemente por garantizar los más altos estándares de protección de la privacidad, por eso nos comprometemos a cumplir tanto con esta política como con todos los requisitos legales relacionados con la protección de sus datos personales.</p>
        <p><b>SAVI MARKETING SOLUTIONS, S.L.</b>, actuará como Responsable del Tratamiento con respecto a los usuarios que naveguen por la página web y respecto los clientes</p>
        <p>Para garantizar alto nivel de seguridad y servicios de alta calidad, lea este documento.</p>
    </div>
</template>
<script>
    export default {
    name : 'Pdp',
    data () {
        return {
          
        }
    }
}
</script>